module.exports = __webpack_public_path__ + "img/excel.20b74a6.svg";